import { render } from "./SellerSelectionStep.vue?vue&type=template&id=88343b84"
import script from "./SellerSelectionStep.vue?vue&type=script&lang=js"
export * from "./SellerSelectionStep.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./SellerSelectionStep.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild_b2e3e009%2Fpackages%2Fstore%2Fsrc%2Fcomponents%2Fquiz%2Fquestions%2FSellerSelectionStep.vue&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__